import React, { useEffect, useRef, useState } from "react";
import { DayOfWeek } from "office-ui-fabric-react";
import { TimeReportingPeriod, findPeriodForDate } from "../../../store/TimeReportingPeriodsStore";
import PeriodNavigator from "../../common/sectionsControl/uiControls/timetracking/PeriodNavigator";

type Props = {
    periods: TimeReportingPeriod[];
    selectedPeriodId: string | undefined;
    onPeriodChange: (period: TimeReportingPeriod) => void;
    firstDayOfWeek: DayOfWeek;
};

const ReportedTimePeriodNavigation = (props: Readonly<Props>) => {
    const [today] = useState(() => new Date());
    const { periods, selectedPeriodId, onPeriodChange, firstDayOfWeek } = props;

    const [currentPeriod, setCurrentPeriod] = useState<TimeReportingPeriod | null>(null);
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (periods.length === 0) {
            return;
        }

        let defaultPeriod: TimeReportingPeriod | undefined;

        if (selectedPeriodId) {
            defaultPeriod = periods.find(p => p.id === selectedPeriodId);
        }

        defaultPeriod ??= findPeriodForDate(today, periods);

        setCurrentPeriod(defaultPeriod ?? periods[0]);
    }, [periods, selectedPeriodId]);

    useEffect(() => {
        if (currentPeriod) {
            if (isInitialMount.current) {
                isInitialMount.current = false;
                return;
            }
            onPeriodChange(currentPeriod);
        }
    }, [currentPeriod?.id]);

    if (!periods.length) {
        return null;
    }

    return (
        <PeriodNavigator
            periods={periods}
            selectedPeriod={currentPeriod}
            onPeriodChange={setCurrentPeriod}
            firstDayOfWeek={firstDayOfWeek}
        />
    );
};

export default ReportedTimePeriodNavigation;
